import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { Marker as MapGlMarker } from "react-map-gl";
import { MarkerAlert, MarkerDefault, MarkerActive } from "@otp/icons";
import { MarkerVariant } from "../types";
import styles from "./marker.module.css";
export function Marker(props) {
    const { longitude, latitude, variant, onClick } = props;
    const MarkerIcon = useMemo(() => {
        switch (variant) {
            case MarkerVariant.Alert:
                return MarkerAlert;
            case MarkerVariant.Active:
                return MarkerActive;
            default:
                return MarkerDefault;
        }
    }, [variant]);
    return (_jsx(MapGlMarker, { longitude: longitude, latitude: latitude, anchor: "bottom", onClick: (e) => {
            // If we let the click event propagates to the map, it will immediately close the popup
            // with `closeOnClick: true`
            e.originalEvent.stopPropagation();
            onClick === null || onClick === void 0 ? void 0 : onClick(props);
        }, children: _jsx(MarkerIcon, { className: styles.markerIcon }) }));
}
export default Marker;
